import { requestNotificationPermission, onMessageListener, initializeFirebase } from '../firebase/firebase';
import { toast } from 'react-toastify';

class NotificationService {
  // Initialize notification service
  async init() {
    try {
      // Initialize Firebase
      initializeFirebase();
      
      // Check if notifications are supported
      if (!('Notification' in window)) {
        console.warn('This browser does not support notifications');
        return { success: false, reason: 'unsupported' };
      }
      
      // Request permission and get token
      const token = await requestNotificationPermission();
      
      if (!token) {
        const reason = Notification.permission === 'denied' ? 'blocked' : 'denied';
        console.log(`Failed to get notification token: ${reason}`);
        return { success: false, reason };
      }
      
      // Set up message listener
      const notificationService = new NotificationService();
      notificationService.setupMessageListener();
      
      return { success: true };
    } catch (error) {
      console.error('Error initializing notifications:', error);
      return { success: false, reason: 'error', error };
    }
  }

  // Set up foreground message listener
  setupMessageListener = () => {
    onMessageListener()
      .then(payload => {
        console.log('Foreground message received:', payload);
        this.showNotification(
          payload.notification.title,
          payload.notification.body
        );
      })
      .catch(err => console.error('Error setting up message listener:', err));
  };

  // Show notification using react-toastify
  showNotification = (title, body) => {
    toast.info(
      <div>
        <strong>{title}</strong>
        <p>{body}</p>
      </div>,
      {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      }
    );
  };
}

// Create and export a singleton instance
const notificationServiceInstance = new NotificationService();
export default notificationServiceInstance;
